export default __webpack_public_path__ + "static/media/5.325ef33c.jpg";